import { Configuration } from '@azure/msal-browser';
const isDevelopment = process.env.NODE_ENV === 'development';

// MSAL configuration
export const configuration: Configuration = {
	auth: {
		clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
		authority: process.env.REACT_APP_AZURE_AUTHORITY!,
		redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI!,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ['User.Read'],
};
